import React from 'react';
import { useTranslations } from 'next-intl';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Button } from '../Wrapper';
import { Section, Limit } from '../Layout';
import { Page } from '../Layout/Page';
import type { ContentUserT } from '../../state/user';

const EmailUsButton = (chunks: React.ReactNode) => (
  <Button variant="secondary" href="mailto:hello@mentimeter.com" m="space1">
    {chunks}
  </Button>
);

const HomepageButton = (chunks: React.ReactNode) => (
  <Button variant="primary" href="/" m="space1">
    {chunks}
  </Button>
);

export const Error = ({
  children,
  user,
}: {
  children: React.ReactNode;
  user: ContentUserT;
}) => {
  const t = useTranslations('first_impression.error');
  return (
    <Page user={user}>
      <Section minHeight={['40vh', '80vh']} justifyContent="center" mb="space0">
        <Limit alignItems="center">
          {children}
          <Box flexDirection={['column', 'row']} alignItems="center">
            {t.rich('actions', {
              EmailUsButton,
              HomepageButton,
            })}
          </Box>
        </Limit>
      </Section>
    </Page>
  );
};
